import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslationPipe } from '../translation.pipe';
import { LanguageCode, LanguageInfo } from '../languages';

@Component({
  selector: 'app-language-selector',
  standalone: true,
  imports: [FormsModule, TranslationPipe],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSelectorComponent {
  @Input({ required: true }) languages!: LanguageInfo[];
  @Input({ required: true }) currentLanguage!: LanguageCode | null;
  @Input() labelTranslationKey = 'languageSelector.label';
  @Input() ariaLabelTranslationKey = 'languageSelector.ariaLabel';

  @Output() languageChange = new EventEmitter<LanguageCode>();

  readonly selectId = `language-selector-${Math.random().toString(36).slice(2, 9)}`;

  get selectedFlag(): string {
    return this.languages.find((lang) => lang.code === this.currentLanguage)?.flag ?? '🌐';
  }

  onSelect(language: LanguageCode | null): void {
    if (language && language !== this.currentLanguage) {
      this.languageChange.emit(language);
    }
  }
}
